module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-orange-01efee2403da4073889d413f305424df.svg";